import { Component, Input } from '@angular/core';
import { RepairRecord } from '../../mock/models/fleet.models';

@Component({
  selector: 'app-maintenance-timeline',
  templateUrl: './maintenance-timeline.component.html',
  styleUrls: ['./maintenance-timeline.component.css'],
})
export class MaintenanceTimelineComponent {
  @Input() repairs: RepairRecord[] = [];

  /** Repuestos ordenados del más reciente al más antiguo. */
  get sortedRepairs(): RepairRecord[] {
    return [...(this.repairs ?? [])].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }

  /** Color del punto según severidad. */
  dotClass(severity: RepairRecord['severity']): string {
    switch (severity) {
      case 'high':
        return 'bg-red-500 ring-red-500/30';
      case 'medium':
        return 'bg-amber-500 ring-amber-500/30';
      default:
        return 'bg-emerald-500 ring-emerald-500/30';
    }
  }

  severityLabel(severity: RepairRecord['severity']): string {
    switch (severity) {
      case 'high':
        return 'Alta';
      case 'medium':
        return 'Media';
      default:
        return 'Baja';
    }
  }

  /** Formatea a pesos colombianos con separador de miles (p.ej. 1.200.000). */
  cop(amount: number | undefined | null): string {
    const n = Math.round(Number(amount ?? 0));
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  severityBadgeClass(severity: RepairRecord['severity']): string {
    switch (severity) {
      case 'high':
        return 'bg-red-500/10 text-red-500';
      case 'medium':
        return 'bg-amber-500/10 text-amber-500';
      default:
        return 'bg-emerald-500/10 text-emerald-500';
    }
  }
}
